import { faBell } from '@fortawesome/pro-duotone-svg-icons'

import Icon from '../icon/Icon'
import { useQuickPassNotifications } from '../../_hooks/use-quickpass-notifications'
import { BellButton, BellGlyph, UnreadBadge } from './styled'
import { NotificationsBellProps } from './types'

const MAX_BADGE_COUNT = 9

/**
 * Header bell that opens the notifications drawer. Shows an unread badge
 * with the current count (capped at "9+" so the chip stays compact).
 *
 * @param {NotificationsBellProps} props
 * @returns {JSX.Element}
 */
const NotificationsBell = ({
  onClick,
}: NotificationsBellProps): JSX.Element => {
  const { unreadCount } = useQuickPassNotifications()
  const hasUnread = unreadCount > 0
  const badgeLabel =
    unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : `${unreadCount}`

  return (
    <BellButton
      type="button"
      onClick={onClick}
      hasUnread={hasUnread}
      aria-label={
        hasUnread === true
          ? `Open notifications (${unreadCount} unread)`
          : 'Open notifications'
      }
    >
      <BellGlyph aria-hidden="true">
        <Icon icon={faBell} />
      </BellGlyph>
      {hasUnread === true ? <UnreadBadge>{badgeLabel}</UnreadBadge> : null}
    </BellButton>
  )
}

export default NotificationsBell
